import { render, staticRenderFns } from "./SwitchRoles.vue?vue&type=template&id=9fd1d034"
import script from "./SwitchRoles.vue?vue&type=script&lang=js"
export * from "./SwitchRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fd1d034')) {
      api.createRecord('9fd1d034', component.options)
    } else {
      api.reload('9fd1d034', component.options)
    }
    module.hot.accept("./SwitchRoles.vue?vue&type=template&id=9fd1d034", function () {
      api.rerender('9fd1d034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/components/SwitchRoles.vue"
export default component.exports